import { Language } from "../model/Language.js";
import { VOWelcome } from "../model/Structure.js";

export interface WelcomeOptions {
    container: HTMLElement;
    data?: VOWelcome;
}

export class Welcome {
    private _element: HTMLElement;
    private _container: HTMLElement;

    constructor(options: WelcomeOptions) {

        this._container = options.container;

        this._element = document.createElement('div');
        this._element.classList.add('welcome');
        this._element.innerHTML = `
        <div class="welcome__background" data-action="close"></div>
        <div class="welcome__content">
            <div class="welcome__body">
                <div class="welcome__title"></div>
                <div class="welcome__description"></div>
            </div>
            <div class="welcome__footer">
                <button class="welcome__close" data-action="close"></button>
            </div>
        </div>
        `;

        if (options.data) {
            this.open(options.data);
        }

        e5.event.on({
            type: "click",
            scope: this._element,
            selector: '[data-action="close"]',
            listener: (e) => {
                this._element.remove();

                e5.tabTrap.pop();
            }
        });
    }

    public async open(data: VOWelcome) {
        this._element.setAttribute("data-e5-edit", data.id + "");

        const title = Language.resolve(data.title_de, data.title_en);
        const titleE = this._element.querySelector('.welcome__title');
        titleE.classList.toggle("hidden", !title);
        if (title) {
            titleE.textContent = title;
        }

        const description = Language.resolve(data.description_de, data.description_en);
        const descriptione = this._element.querySelector('.welcome__description');
        descriptione.classList.toggle("hidden", !title);
        if (description) {
            descriptione.innerHTML = description;
        }

        const buttonLabel = Language.resolve(data.button_label_de, data.button_label_en);
        const closeButton = this._element.querySelector('.welcome__close');
        closeButton.classList.toggle("hidden", !buttonLabel);
        this._element.querySelector(".welcome__footer").classList.toggle("hidden", !buttonLabel);
        if (buttonLabel) {
            closeButton.textContent = buttonLabel;
        }

        this._container.appendChild(this._element);

        e5.tabTrap.push({
            element: this._element,
            // focus: "first"
        });
    }
}